export type CommerceCountry = {
  code: string;
  code3: string;
  name: string;
  currency: string;
  units: string;
  priceIncludesTax: boolean;
  continent: string;
  group: string;
};

export const popularCommerceCountryList: Array<CommerceCountry> = [
  {
    code: 'US',
    code3: 'USA',
    name: 'United States',
    currency: 'USD',
    units: 'imperial',
    priceIncludesTax: false,
    continent: 'NA',
    group: 'Popular countries',
  },
  {
    code: 'GB',
    code3: 'GBR',
    name: 'United Kingdom',
    currency: 'GBP',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'EU',
    group: 'Popular countries',
  },
  {
    code: 'CA',
    code3: 'CAN',
    name: 'Canada',
    currency: 'CAD',
    units: 'metric',
    priceIncludesTax: false,
    continent: 'NA',
    group: 'Popular countries',
  },
];

// Built by running `./bin/babel-run ./entrypoints/server/ops/refreshCountryList.js`
export const commerceCountryList: Array<CommerceCountry> = [
  {
    code: 'AF',
    code3: 'AFG',
    name: 'Afghanistan',
    currency: 'AFN',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AS',
    group: 'All countries',
  },
  {
    code: 'AX',
    code3: 'ALA',
    name: 'Aland Islands',
    currency: 'EUR',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'EU',
    group: 'All countries',
  },
  {
    code: 'AL',
    code3: 'ALB',
    name: 'Albania',
    currency: 'ALL',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'EU',
    group: 'All countries',
  },
  {
    code: 'DZ',
    code3: 'DZA',
    name: 'Algeria',
    currency: 'DZD',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AF',
    group: 'All countries',
  },
  {
    code: 'AS',
    code3: 'ASM',
    name: 'American Samoa',
    currency: 'USD',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'OC',
    group: 'All countries',
  },
  {
    code: 'AD',
    code3: 'AND',
    name: 'Andorra',
    currency: 'EUR',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'EU',
    group: 'All countries',
  },
  {
    code: 'AO',
    code3: 'AGO',
    name: 'Angola',
    currency: 'AOA',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AF',
    group: 'All countries',
  },
  {
    code: 'AI',
    code3: 'AIA',
    name: 'Anguilla',
    currency: 'XCD',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'NA',
    group: 'All countries',
  },
  {
    code: 'AG',
    code3: 'ATG',
    name: 'Antigua and Barbuda',
    currency: 'XCD',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'NA',
    group: 'All countries',
  },
  {
    code: 'AR',
    code3: 'ARG',
    name: 'Argentina',
    currency: 'ARS',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'SA',
    group: 'All countries',
  },
  {
    code: 'AM',
    code3: 'ARM',
    name: 'Armenia',
    currency: 'AMD',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AS',
    group: 'All countries',
  },
  {
    code: 'AW',
    code3: 'ABW',
    name: 'Aruba',
    currency: 'AWG',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'NA',
    group: 'All countries',
  },
  {
    code: 'AU',
    code3: 'AUS',
    name: 'Australia',
    currency: 'AUD',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'OC',
    group: 'All countries',
  },
  {
    code: 'AT',
    code3: 'AUT',
    name: 'Austria',
    currency: 'EUR',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'EU',
    group: 'All countries',
  },
  {
    code: 'AZ',
    code3: 'AZE',
    name: 'Azerbaijan',
    currency: 'AZN',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AS',
    group: 'All countries',
  },
  {
    code: 'BS',
    code3: 'BHS',
    name: 'Bahamas',
    currency: 'BSD',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'NA',
    group: 'All countries',
  },
  {
    code: 'BH',
    code3: 'BHR',
    name: 'Bahrain',
    currency: 'BHD',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AS',
    group: 'All countries',
  },
  {
    code: 'BD',
    code3: 'BGD',
    name: 'Bangladesh',
    currency: 'BDT',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AS',
    group: 'All countries',
  },
  {
    code: 'BB',
    code3: 'BRB',
    name: 'Barbados',
    currency: 'BBD',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'NA',
    group: 'All countries',
  },
  {
    code: 'BY',
    code3: 'BLR',
    name: 'Belarus',
    currency: 'BYN',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'EU',
    group: 'All countries',
  },
  {
    code: 'BE',
    code3: 'BEL',
    name: 'Belgium',
    currency: 'EUR',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'EU',
    group: 'All countries',
  },
  {
    code: 'BZ',
    code3: 'BLZ',
    name: 'Belize',
    currency: 'BZD',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'NA',
    group: 'All countries',
  },
  {
    code: 'BJ',
    code3: 'BEN',
    name: 'Benin',
    currency: 'XOF',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AF',
    group: 'All countries',
  },
  {
    code: 'BM',
    code3: 'BMU',
    name: 'Bermuda',
    currency: 'BMD',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'NA',
    group: 'All countries',
  },
  {
    code: 'BT',
    code3: 'BTN',
    name: 'Bhutan',
    currency: 'BTN',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AS',
    group: 'All countries',
  },
  {
    code: 'BO',
    code3: 'BOL',
    name: 'Bolivia',
    currency: 'BOB',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'SA',
    group: 'All countries',
  },
  {
    code: 'BQ',
    code3: 'BES',
    name: 'Bonaire, Saint Eustatius and Saba',
    currency: 'USD',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'NA',
    group: 'All countries',
  },
  {
    code: 'BA',
    code3: 'BIH',
    name: 'Bosnia and Herzegovina',
    currency: 'BAM',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'EU',
    group: 'All countries',
  },
  {
    code: 'BW',
    code3: 'BWA',
    name: 'Botswana',
    currency: 'BWP',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AF',
    group: 'All countries',
  },
  {
    code: 'BR',
    code3: 'BRA',
    name: 'Brazil',
    currency: 'BRL',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'SA',
    group: 'All countries',
  },
  {
    code: 'IO',
    code3: 'IOT',
    name: 'British Indian Ocean Territory',
    currency: 'USD',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AS',
    group: 'All countries',
  },
  {
    code: 'VG',
    code3: 'VGB',
    name: 'British Virgin Islands',
    currency: 'USD',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'NA',
    group: 'All countries',
  },
  {
    code: 'BN',
    code3: 'BRN',
    name: 'Brunei',
    currency: 'BND',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AS',
    group: 'All countries',
  },
  {
    code: 'BG',
    code3: 'BGR',
    name: 'Bulgaria',
    currency: 'BGN',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'EU',
    group: 'All countries',
  },
  {
    code: 'BF',
    code3: 'BFA',
    name: 'Burkina Faso',
    currency: 'XOF',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AF',
    group: 'All countries',
  },
  {
    code: 'BI',
    code3: 'BDI',
    name: 'Burundi',
    currency: 'BIF',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AF',
    group: 'All countries',
  },
  {
    code: 'CV',
    code3: 'CPV',
    name: 'Cabo Verde',
    currency: 'CVE',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AF',
    group: 'All countries',
  },
  {
    code: 'KH',
    code3: 'KHM',
    name: 'Cambodia',
    currency: 'KHR',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AS',
    group: 'All countries',
  },
  {
    code: 'CM',
    code3: 'CMR',
    name: 'Cameroon',
    currency: 'XAF',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AF',
    group: 'All countries',
  },
  {
    code: 'CA',
    code3: 'CAN',
    name: 'Canada',
    currency: 'CAD',
    units: 'metric',
    priceIncludesTax: false,
    continent: 'NA',
    group: 'All countries',
  },
  {
    code: 'KY',
    code3: 'CYM',
    name: 'Cayman Islands',
    currency: 'KYD',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'NA',
    group: 'All countries',
  },
  {
    code: 'CF',
    code3: 'CAF',
    name: 'Central African Republic',
    currency: 'XAF',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AF',
    group: 'All countries',
  },
  {
    code: 'TD',
    code3: 'TCD',
    name: 'Chad',
    currency: 'XAF',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AF',
    group: 'All countries',
  },
  {
    code: 'CL',
    code3: 'CHL',
    name: 'Chile',
    currency: 'CLP',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'SA',
    group: 'All countries',
  },
  {
    code: 'CN',
    code3: 'CHN',
    name: 'China',
    currency: 'CNY',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AS',
    group: 'All countries',
  },
  {
    code: 'CX',
    code3: 'CXR',
    name: 'Christmas Island',
    currency: 'AUD',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'OC',
    group: 'All countries',
  },
  {
    code: 'CC',
    code3: 'CCK',
    name: 'Cocos Islands',
    currency: 'AUD',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AS',
    group: 'All countries',
  },
  {
    code: 'CO',
    code3: 'COL',
    name: 'Colombia',
    currency: 'COP',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'SA',
    group: 'All countries',
  },
  {
    code: 'KM',
    code3: 'COM',
    name: 'Comoros',
    currency: 'KMF',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AF',
    group: 'All countries',
  },
  {
    code: 'CK',
    code3: 'COK',
    name: 'Cook Islands',
    currency: 'NZD',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'OC',
    group: 'All countries',
  },
  {
    code: 'CR',
    code3: 'CRI',
    name: 'Costa Rica',
    currency: 'CRC',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'NA',
    group: 'All countries',
  },
  {
    code: 'HR',
    code3: 'HRV',
    name: 'Croatia',
    currency: 'HRK',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'EU',
    group: 'All countries',
  },
  {
    code: 'CU',
    code3: 'CUB',
    name: 'Cuba',
    currency: 'CUP',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'NA',
    group: 'All countries',
  },
  {
    code: 'CW',
    code3: 'CUW',
    name: 'Curacao',
    currency: 'ANG',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'NA',
    group: 'All countries',
  },
  {
    code: 'CY',
    code3: 'CYP',
    name: 'Cyprus',
    currency: 'EUR',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'EU',
    group: 'All countries',
  },
  {
    code: 'CZ',
    code3: 'CZE',
    name: 'Czechia',
    currency: 'CZK',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'EU',
    group: 'All countries',
  },
  {
    code: 'CD',
    code3: 'COD',
    name: 'Democratic Republic of the Congo',
    currency: 'CDF',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AF',
    group: 'All countries',
  },
  {
    code: 'DK',
    code3: 'DNK',
    name: 'Denmark',
    currency: 'DKK',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'EU',
    group: 'All countries',
  },
  {
    code: 'DJ',
    code3: 'DJI',
    name: 'Djibouti',
    currency: 'DJF',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AF',
    group: 'All countries',
  },
  {
    code: 'DM',
    code3: 'DMA',
    name: 'Dominica',
    currency: 'XCD',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'NA',
    group: 'All countries',
  },
  {
    code: 'DO',
    code3: 'DOM',
    name: 'Dominican Republic',
    currency: 'DOP',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'NA',
    group: 'All countries',
  },
  {
    code: 'EC',
    code3: 'ECU',
    name: 'Ecuador',
    currency: 'USD',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'SA',
    group: 'All countries',
  },
  {
    code: 'EG',
    code3: 'EGY',
    name: 'Egypt',
    currency: 'EGP',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AF',
    group: 'All countries',
  },
  {
    code: 'SV',
    code3: 'SLV',
    name: 'El Salvador',
    currency: 'USD',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'NA',
    group: 'All countries',
  },
  {
    code: 'GQ',
    code3: 'GNQ',
    name: 'Equatorial Guinea',
    currency: 'XAF',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AF',
    group: 'All countries',
  },
  {
    code: 'ER',
    code3: 'ERI',
    name: 'Eritrea',
    currency: 'ERN',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AF',
    group: 'All countries',
  },
  {
    code: 'EE',
    code3: 'EST',
    name: 'Estonia',
    currency: 'EUR',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'EU',
    group: 'All countries',
  },
  {
    code: 'SZ',
    code3: 'SWZ',
    name: 'Eswatini',
    currency: 'SZL',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AF',
    group: 'All countries',
  },
  {
    code: 'ET',
    code3: 'ETH',
    name: 'Ethiopia',
    currency: 'ETB',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AF',
    group: 'All countries',
  },
  {
    code: 'FK',
    code3: 'FLK',
    name: 'Falkland Islands',
    currency: 'FKP',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'SA',
    group: 'All countries',
  },
  {
    code: 'FO',
    code3: 'FRO',
    name: 'Faroe Islands',
    currency: 'DKK',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'EU',
    group: 'All countries',
  },
  {
    code: 'FJ',
    code3: 'FJI',
    name: 'Fiji',
    currency: 'FJD',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'OC',
    group: 'All countries',
  },
  {
    code: 'FI',
    code3: 'FIN',
    name: 'Finland',
    currency: 'EUR',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'EU',
    group: 'All countries',
  },
  {
    code: 'FR',
    code3: 'FRA',
    name: 'France',
    currency: 'EUR',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'EU',
    group: 'All countries',
  },
  {
    code: 'GF',
    code3: 'GUF',
    name: 'French Guiana',
    currency: 'EUR',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'SA',
    group: 'All countries',
  },
  {
    code: 'PF',
    code3: 'PYF',
    name: 'French Polynesia',
    currency: 'XPF',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'OC',
    group: 'All countries',
  },
  {
    code: 'TF',
    code3: 'ATF',
    name: 'French Southern Territories',
    currency: 'EUR',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AN',
    group: 'All countries',
  },
  {
    code: 'GA',
    code3: 'GAB',
    name: 'Gabon',
    currency: 'XAF',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AF',
    group: 'All countries',
  },
  {
    code: 'GM',
    code3: 'GMB',
    name: 'Gambia',
    currency: 'GMD',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AF',
    group: 'All countries',
  },
  {
    code: 'GE',
    code3: 'GEO',
    name: 'Georgia',
    currency: 'GEL',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AS',
    group: 'All countries',
  },
  {
    code: 'DE',
    code3: 'DEU',
    name: 'Germany',
    currency: 'EUR',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'EU',
    group: 'All countries',
  },
  {
    code: 'GH',
    code3: 'GHA',
    name: 'Ghana',
    currency: 'GHS',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AF',
    group: 'All countries',
  },
  {
    code: 'GI',
    code3: 'GIB',
    name: 'Gibraltar',
    currency: 'GIP',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'EU',
    group: 'All countries',
  },
  {
    code: 'GR',
    code3: 'GRC',
    name: 'Greece',
    currency: 'EUR',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'EU',
    group: 'All countries',
  },
  {
    code: 'GL',
    code3: 'GRL',
    name: 'Greenland',
    currency: 'DKK',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'NA',
    group: 'All countries',
  },
  {
    code: 'GD',
    code3: 'GRD',
    name: 'Grenada',
    currency: 'XCD',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'NA',
    group: 'All countries',
  },
  {
    code: 'GP',
    code3: 'GLP',
    name: 'Guadeloupe',
    currency: 'EUR',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'NA',
    group: 'All countries',
  },
  {
    code: 'GU',
    code3: 'GUM',
    name: 'Guam',
    currency: 'USD',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'OC',
    group: 'All countries',
  },
  {
    code: 'GT',
    code3: 'GTM',
    name: 'Guatemala',
    currency: 'GTQ',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'NA',
    group: 'All countries',
  },
  {
    code: 'GG',
    code3: 'GGY',
    name: 'Guernsey',
    currency: 'GBP',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'EU',
    group: 'All countries',
  },
  {
    code: 'GN',
    code3: 'GIN',
    name: 'Guinea',
    currency: 'GNF',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AF',
    group: 'All countries',
  },
  {
    code: 'GW',
    code3: 'GNB',
    name: 'Guinea-Bissau',
    currency: 'XOF',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AF',
    group: 'All countries',
  },
  {
    code: 'GY',
    code3: 'GUY',
    name: 'Guyana',
    currency: 'GYD',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'SA',
    group: 'All countries',
  },
  {
    code: 'HT',
    code3: 'HTI',
    name: 'Haiti',
    currency: 'HTG',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'NA',
    group: 'All countries',
  },
  {
    code: 'HN',
    code3: 'HND',
    name: 'Honduras',
    currency: 'HNL',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'NA',
    group: 'All countries',
  },
  {
    code: 'HK',
    code3: 'HKG',
    name: 'Hong Kong',
    currency: 'HKD',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AS',
    group: 'All countries',
  },
  {
    code: 'HU',
    code3: 'HUN',
    name: 'Hungary',
    currency: 'HUF',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'EU',
    group: 'All countries',
  },
  {
    code: 'IS',
    code3: 'ISL',
    name: 'Iceland',
    currency: 'ISK',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'EU',
    group: 'All countries',
  },
  {
    code: 'IN',
    code3: 'IND',
    name: 'India',
    currency: 'INR',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AS',
    group: 'All countries',
  },
  {
    code: 'ID',
    code3: 'IDN',
    name: 'Indonesia',
    currency: 'IDR',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AS',
    group: 'All countries',
  },
  {
    code: 'IR',
    code3: 'IRN',
    name: 'Iran',
    currency: 'IRR',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AS',
    group: 'All countries',
  },
  {
    code: 'IQ',
    code3: 'IRQ',
    name: 'Iraq',
    currency: 'IQD',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AS',
    group: 'All countries',
  },
  {
    code: 'IE',
    code3: 'IRL',
    name: 'Ireland',
    currency: 'EUR',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'EU',
    group: 'All countries',
  },
  {
    code: 'IM',
    code3: 'IMN',
    name: 'Isle of Man',
    currency: 'GBP',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'EU',
    group: 'All countries',
  },
  {
    code: 'IL',
    code3: 'ISR',
    name: 'Israel',
    currency: 'ILS',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AS',
    group: 'All countries',
  },
  {
    code: 'IT',
    code3: 'ITA',
    name: 'Italy',
    currency: 'EUR',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'EU',
    group: 'All countries',
  },
  {
    code: 'CI',
    code3: 'CIV',
    name: 'Ivory Coast',
    currency: 'XOF',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AF',
    group: 'All countries',
  },
  {
    code: 'JM',
    code3: 'JAM',
    name: 'Jamaica',
    currency: 'JMD',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'NA',
    group: 'All countries',
  },
  {
    code: 'JP',
    code3: 'JPN',
    name: 'Japan',
    currency: 'JPY',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AS',
    group: 'All countries',
  },
  {
    code: 'JE',
    code3: 'JEY',
    name: 'Jersey',
    currency: 'GBP',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'EU',
    group: 'All countries',
  },
  {
    code: 'JO',
    code3: 'JOR',
    name: 'Jordan',
    currency: 'JOD',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AS',
    group: 'All countries',
  },
  {
    code: 'KZ',
    code3: 'KAZ',
    name: 'Kazakhstan',
    currency: 'KZT',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AS',
    group: 'All countries',
  },
  {
    code: 'KE',
    code3: 'KEN',
    name: 'Kenya',
    currency: 'KES',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AF',
    group: 'All countries',
  },
  {
    code: 'KI',
    code3: 'KIR',
    name: 'Kiribati',
    currency: 'AUD',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'OC',
    group: 'All countries',
  },
  {
    code: 'XK',
    code3: 'XKX',
    name: 'Kosovo',
    currency: 'EUR',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'EU',
    group: 'All countries',
  },
  {
    code: 'KW',
    code3: 'KWT',
    name: 'Kuwait',
    currency: 'KWD',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AS',
    group: 'All countries',
  },
  {
    code: 'KG',
    code3: 'KGZ',
    name: 'Kyrgyzstan',
    currency: 'KGS',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AS',
    group: 'All countries',
  },
  {
    code: 'LA',
    code3: 'LAO',
    name: 'Laos',
    currency: 'LAK',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AS',
    group: 'All countries',
  },
  {
    code: 'LV',
    code3: 'LVA',
    name: 'Latvia',
    currency: 'EUR',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'EU',
    group: 'All countries',
  },
  {
    code: 'LB',
    code3: 'LBN',
    name: 'Lebanon',
    currency: 'LBP',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AS',
    group: 'All countries',
  },
  {
    code: 'LS',
    code3: 'LSO',
    name: 'Lesotho',
    currency: 'LSL',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AF',
    group: 'All countries',
  },
  {
    code: 'LR',
    code3: 'LBR',
    name: 'Liberia',
    currency: 'LRD',
    units: 'imperial',
    priceIncludesTax: true,
    continent: 'AF',
    group: 'All countries',
  },
  {
    code: 'LY',
    code3: 'LBY',
    name: 'Libya',
    currency: 'LYD',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AF',
    group: 'All countries',
  },
  {
    code: 'LI',
    code3: 'LIE',
    name: 'Liechtenstein',
    currency: 'CHF',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'EU',
    group: 'All countries',
  },
  {
    code: 'LT',
    code3: 'LTU',
    name: 'Lithuania',
    currency: 'EUR',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'EU',
    group: 'All countries',
  },
  {
    code: 'LU',
    code3: 'LUX',
    name: 'Luxembourg',
    currency: 'EUR',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'EU',
    group: 'All countries',
  },
  {
    code: 'MO',
    code3: 'MAC',
    name: 'Macao',
    currency: 'MOP',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AS',
    group: 'All countries',
  },
  {
    code: 'MG',
    code3: 'MDG',
    name: 'Madagascar',
    currency: 'MGA',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AF',
    group: 'All countries',
  },
  {
    code: 'MW',
    code3: 'MWI',
    name: 'Malawi',
    currency: 'MWK',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AF',
    group: 'All countries',
  },
  {
    code: 'MY',
    code3: 'MYS',
    name: 'Malaysia',
    currency: 'MYR',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AS',
    group: 'All countries',
  },
  {
    code: 'MV',
    code3: 'MDV',
    name: 'Maldives',
    currency: 'MVR',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AS',
    group: 'All countries',
  },
  {
    code: 'ML',
    code3: 'MLI',
    name: 'Mali',
    currency: 'XOF',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AF',
    group: 'All countries',
  },
  {
    code: 'MT',
    code3: 'MLT',
    name: 'Malta',
    currency: 'EUR',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'EU',
    group: 'All countries',
  },
  {
    code: 'MH',
    code3: 'MHL',
    name: 'Marshall Islands',
    currency: 'USD',
    units: 'imperial',
    priceIncludesTax: false,
    continent: 'OC',
    group: 'All countries',
  },
  {
    code: 'MQ',
    code3: 'MTQ',
    name: 'Martinique',
    currency: 'EUR',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'NA',
    group: 'All countries',
  },
  {
    code: 'MR',
    code3: 'MRT',
    name: 'Mauritania',
    currency: 'MRU',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AF',
    group: 'All countries',
  },
  {
    code: 'MU',
    code3: 'MUS',
    name: 'Mauritius',
    currency: 'MUR',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AF',
    group: 'All countries',
  },
  {
    code: 'YT',
    code3: 'MYT',
    name: 'Mayotte',
    currency: 'EUR',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AF',
    group: 'All countries',
  },
  {
    code: 'MX',
    code3: 'MEX',
    name: 'Mexico',
    currency: 'MXN',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'NA',
    group: 'All countries',
  },
  {
    code: 'FM',
    code3: 'FSM',
    name: 'Micronesia',
    currency: 'USD',
    units: 'imperial',
    priceIncludesTax: false,
    continent: 'OC',
    group: 'All countries',
  },
  {
    code: 'MD',
    code3: 'MDA',
    name: 'Moldova',
    currency: 'MDL',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'EU',
    group: 'All countries',
  },
  {
    code: 'MC',
    code3: 'MCO',
    name: 'Monaco',
    currency: 'EUR',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'EU',
    group: 'All countries',
  },
  {
    code: 'MN',
    code3: 'MNG',
    name: 'Mongolia',
    currency: 'MNT',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AS',
    group: 'All countries',
  },
  {
    code: 'ME',
    code3: 'MNE',
    name: 'Montenegro',
    currency: 'EUR',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'EU',
    group: 'All countries',
  },
  {
    code: 'MS',
    code3: 'MSR',
    name: 'Montserrat',
    currency: 'XCD',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'NA',
    group: 'All countries',
  },
  {
    code: 'MA',
    code3: 'MAR',
    name: 'Morocco',
    currency: 'MAD',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AF',
    group: 'All countries',
  },
  {
    code: 'MZ',
    code3: 'MOZ',
    name: 'Mozambique',
    currency: 'MZN',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AF',
    group: 'All countries',
  },
  {
    code: 'MM',
    code3: 'MMR',
    name: 'Myanmar',
    currency: 'MMK',
    units: 'imperial',
    priceIncludesTax: true,
    continent: 'AS',
    group: 'All countries',
  },
  {
    code: 'NA',
    code3: 'NAM',
    name: 'Namibia',
    currency: 'NAD',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AF',
    group: 'All countries',
  },
  {
    code: 'NR',
    code3: 'NRU',
    name: 'Nauru',
    currency: 'AUD',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'OC',
    group: 'All countries',
  },
  {
    code: 'NP',
    code3: 'NPL',
    name: 'Nepal',
    currency: 'NPR',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AS',
    group: 'All countries',
  },
  {
    code: 'NL',
    code3: 'NLD',
    name: 'Netherlands',
    currency: 'EUR',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'EU',
    group: 'All countries',
  },
  {
    code: 'NC',
    code3: 'NCL',
    name: 'New Caledonia',
    currency: 'XPF',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'OC',
    group: 'All countries',
  },
  {
    code: 'NZ',
    code3: 'NZL',
    name: 'New Zealand',
    currency: 'NZD',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'OC',
    group: 'All countries',
  },
  {
    code: 'NI',
    code3: 'NIC',
    name: 'Nicaragua',
    currency: 'NIO',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'NA',
    group: 'All countries',
  },
  {
    code: 'NE',
    code3: 'NER',
    name: 'Niger',
    currency: 'XOF',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AF',
    group: 'All countries',
  },
  {
    code: 'NG',
    code3: 'NGA',
    name: 'Nigeria',
    currency: 'NGN',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AF',
    group: 'All countries',
  },
  {
    code: 'NU',
    code3: 'NIU',
    name: 'Niue',
    currency: 'NZD',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'OC',
    group: 'All countries',
  },
  {
    code: 'NF',
    code3: 'NFK',
    name: 'Norfolk Island',
    currency: 'AUD',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'OC',
    group: 'All countries',
  },
  {
    code: 'KP',
    code3: 'PRK',
    name: 'North Korea',
    currency: 'KPW',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AS',
    group: 'All countries',
  },
  {
    code: 'MK',
    code3: 'MKD',
    name: 'North Macedonia',
    currency: 'MKD',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'EU',
    group: 'All countries',
  },
  {
    code: 'MP',
    code3: 'MNP',
    name: 'Northern Mariana Islands',
    currency: 'USD',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'OC',
    group: 'All countries',
  },
  {
    code: 'NO',
    code3: 'NOR',
    name: 'Norway',
    currency: 'NOK',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'EU',
    group: 'All countries',
  },
  {
    code: 'OM',
    code3: 'OMN',
    name: 'Oman',
    currency: 'OMR',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AS',
    group: 'All countries',
  },
  {
    code: 'PK',
    code3: 'PAK',
    name: 'Pakistan',
    currency: 'PKR',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AS',
    group: 'All countries',
  },
  {
    code: 'PW',
    code3: 'PLW',
    name: 'Palau',
    currency: 'USD',
    units: 'imperial',
    priceIncludesTax: false,
    continent: 'OC',
    group: 'All countries',
  },
  {
    code: 'PS',
    code3: 'PSE',
    name: 'Palestinian Territory',
    currency: 'ILS',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AS',
    group: 'All countries',
  },
  {
    code: 'PA',
    code3: 'PAN',
    name: 'Panama',
    currency: 'PAB',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'NA',
    group: 'All countries',
  },
  {
    code: 'PG',
    code3: 'PNG',
    name: 'Papua New Guinea',
    currency: 'PGK',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'OC',
    group: 'All countries',
  },
  {
    code: 'PY',
    code3: 'PRY',
    name: 'Paraguay',
    currency: 'PYG',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'SA',
    group: 'All countries',
  },
  {
    code: 'PE',
    code3: 'PER',
    name: 'Peru',
    currency: 'PEN',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'SA',
    group: 'All countries',
  },
  {
    code: 'PH',
    code3: 'PHL',
    name: 'Philippines',
    currency: 'PHP',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AS',
    group: 'All countries',
  },
  {
    code: 'PN',
    code3: 'PCN',
    name: 'Pitcairn',
    currency: 'NZD',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'OC',
    group: 'All countries',
  },
  {
    code: 'PL',
    code3: 'POL',
    name: 'Poland',
    currency: 'PLN',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'EU',
    group: 'All countries',
  },
  {
    code: 'PT',
    code3: 'PRT',
    name: 'Portugal',
    currency: 'EUR',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'EU',
    group: 'All countries',
  },
  {
    code: 'PR',
    code3: 'PRI',
    name: 'Puerto Rico',
    currency: 'USD',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'NA',
    group: 'All countries',
  },
  {
    code: 'QA',
    code3: 'QAT',
    name: 'Qatar',
    currency: 'QAR',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AS',
    group: 'All countries',
  },
  {
    code: 'CG',
    code3: 'COG',
    name: 'Republic of the Congo',
    currency: 'XAF',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AF',
    group: 'All countries',
  },
  {
    code: 'RE',
    code3: 'REU',
    name: 'Reunion',
    currency: 'EUR',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AF',
    group: 'All countries',
  },
  {
    code: 'RO',
    code3: 'ROU',
    name: 'Romania',
    currency: 'RON',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'EU',
    group: 'All countries',
  },
  {
    code: 'RU',
    code3: 'RUS',
    name: 'Russia',
    currency: 'RUB',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'EU',
    group: 'All countries',
  },
  {
    code: 'RW',
    code3: 'RWA',
    name: 'Rwanda',
    currency: 'RWF',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AF',
    group: 'All countries',
  },
  {
    code: 'BL',
    code3: 'BLM',
    name: 'Saint Barthelemy',
    currency: 'EUR',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'NA',
    group: 'All countries',
  },
  {
    code: 'SH',
    code3: 'SHN',
    name: 'Saint Helena',
    currency: 'SHP',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AF',
    group: 'All countries',
  },
  {
    code: 'KN',
    code3: 'KNA',
    name: 'Saint Kitts and Nevis',
    currency: 'XCD',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'NA',
    group: 'All countries',
  },
  {
    code: 'LC',
    code3: 'LCA',
    name: 'Saint Lucia',
    currency: 'XCD',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'NA',
    group: 'All countries',
  },
  {
    code: 'MF',
    code3: 'MAF',
    name: 'Saint Martin',
    currency: 'EUR',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'NA',
    group: 'All countries',
  },
  {
    code: 'PM',
    code3: 'SPM',
    name: 'Saint Pierre and Miquelon',
    currency: 'EUR',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'NA',
    group: 'All countries',
  },
  {
    code: 'VC',
    code3: 'VCT',
    name: 'Saint Vincent and the Grenadines',
    currency: 'XCD',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'NA',
    group: 'All countries',
  },
  {
    code: 'WS',
    code3: 'WSM',
    name: 'Samoa',
    currency: 'WST',
    units: 'imperial',
    priceIncludesTax: false,
    continent: 'OC',
    group: 'All countries',
  },
  {
    code: 'SM',
    code3: 'SMR',
    name: 'San Marino',
    currency: 'EUR',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'EU',
    group: 'All countries',
  },
  {
    code: 'ST',
    code3: 'STP',
    name: 'Sao Tome and Principe',
    currency: 'STN',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AF',
    group: 'All countries',
  },
  {
    code: 'SA',
    code3: 'SAU',
    name: 'Saudi Arabia',
    currency: 'SAR',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AS',
    group: 'All countries',
  },
  {
    code: 'SN',
    code3: 'SEN',
    name: 'Senegal',
    currency: 'XOF',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AF',
    group: 'All countries',
  },
  {
    code: 'RS',
    code3: 'SRB',
    name: 'Serbia',
    currency: 'RSD',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'EU',
    group: 'All countries',
  },
  {
    code: 'SC',
    code3: 'SYC',
    name: 'Seychelles',
    currency: 'SCR',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AF',
    group: 'All countries',
  },
  {
    code: 'SL',
    code3: 'SLE',
    name: 'Sierra Leone',
    currency: 'SLL',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AF',
    group: 'All countries',
  },
  {
    code: 'SG',
    code3: 'SGP',
    name: 'Singapore',
    currency: 'SGD',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AS',
    group: 'All countries',
  },
  {
    code: 'SX',
    code3: 'SXM',
    name: 'Sint Maarten',
    currency: 'ANG',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'NA',
    group: 'All countries',
  },
  {
    code: 'SK',
    code3: 'SVK',
    name: 'Slovakia',
    currency: 'EUR',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'EU',
    group: 'All countries',
  },
  {
    code: 'SI',
    code3: 'SVN',
    name: 'Slovenia',
    currency: 'EUR',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'EU',
    group: 'All countries',
  },
  {
    code: 'SB',
    code3: 'SLB',
    name: 'Solomon Islands',
    currency: 'SBD',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'OC',
    group: 'All countries',
  },
  {
    code: 'SO',
    code3: 'SOM',
    name: 'Somalia',
    currency: 'SOS',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AF',
    group: 'All countries',
  },
  {
    code: 'ZA',
    code3: 'ZAF',
    name: 'South Africa',
    currency: 'ZAR',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AF',
    group: 'All countries',
  },
  {
    code: 'GS',
    code3: 'SGS',
    name: 'South Georgia and the South Sandwich Islands',
    currency: 'GBP',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AN',
    group: 'All countries',
  },
  {
    code: 'KR',
    code3: 'KOR',
    name: 'South Korea',
    currency: 'KRW',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AS',
    group: 'All countries',
  },
  {
    code: 'SS',
    code3: 'SSD',
    name: 'South Sudan',
    currency: 'SSP',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AF',
    group: 'All countries',
  },
  {
    code: 'ES',
    code3: 'ESP',
    name: 'Spain',
    currency: 'EUR',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'EU',
    group: 'All countries',
  },
  {
    code: 'LK',
    code3: 'LKA',
    name: 'Sri Lanka',
    currency: 'LKR',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AS',
    group: 'All countries',
  },
  {
    code: 'SD',
    code3: 'SDN',
    name: 'Sudan',
    currency: 'SDG',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AF',
    group: 'All countries',
  },
  {
    code: 'SR',
    code3: 'SUR',
    name: 'Suriname',
    currency: 'SRD',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'SA',
    group: 'All countries',
  },
  {
    code: 'SJ',
    code3: 'SJM',
    name: 'Svalbard and Jan Mayen',
    currency: 'NOK',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'EU',
    group: 'All countries',
  },
  {
    code: 'SE',
    code3: 'SWE',
    name: 'Sweden',
    currency: 'SEK',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'EU',
    group: 'All countries',
  },
  {
    code: 'CH',
    code3: 'CHE',
    name: 'Switzerland',
    currency: 'CHF',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'EU',
    group: 'All countries',
  },
  {
    code: 'SY',
    code3: 'SYR',
    name: 'Syria',
    currency: 'SYP',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AS',
    group: 'All countries',
  },
  {
    code: 'TW',
    code3: 'TWN',
    name: 'Taiwan',
    currency: 'TWD',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AS',
    group: 'All countries',
  },
  {
    code: 'TJ',
    code3: 'TJK',
    name: 'Tajikistan',
    currency: 'TJS',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AS',
    group: 'All countries',
  },
  {
    code: 'TZ',
    code3: 'TZA',
    name: 'Tanzania',
    currency: 'TZS',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AF',
    group: 'All countries',
  },
  {
    code: 'TH',
    code3: 'THA',
    name: 'Thailand',
    currency: 'THB',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AS',
    group: 'All countries',
  },
  {
    code: 'TL',
    code3: 'TLS',
    name: 'Timor Leste',
    currency: 'USD',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'OC',
    group: 'All countries',
  },
  {
    code: 'TG',
    code3: 'TGO',
    name: 'Togo',
    currency: 'XOF',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AF',
    group: 'All countries',
  },
  {
    code: 'TK',
    code3: 'TKL',
    name: 'Tokelau',
    currency: 'NZD',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'OC',
    group: 'All countries',
  },
  {
    code: 'TO',
    code3: 'TON',
    name: 'Tonga',
    currency: 'TOP',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'OC',
    group: 'All countries',
  },
  {
    code: 'TT',
    code3: 'TTO',
    name: 'Trinidad and Tobago',
    currency: 'TTD',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'NA',
    group: 'All countries',
  },
  {
    code: 'TN',
    code3: 'TUN',
    name: 'Tunisia',
    currency: 'TND',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AF',
    group: 'All countries',
  },
  {
    code: 'TR',
    code3: 'TUR',
    name: 'Turkey',
    currency: 'TRY',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AS',
    group: 'All countries',
  },
  {
    code: 'TM',
    code3: 'TKM',
    name: 'Turkmenistan',
    currency: 'TMT',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AS',
    group: 'All countries',
  },
  {
    code: 'TC',
    code3: 'TCA',
    name: 'Turks and Caicos Islands',
    currency: 'USD',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'NA',
    group: 'All countries',
  },
  {
    code: 'TV',
    code3: 'TUV',
    name: 'Tuvalu',
    currency: 'AUD',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'OC',
    group: 'All countries',
  },
  {
    code: 'VI',
    code3: 'VIR',
    name: 'U.S. Virgin Islands',
    currency: 'USD',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'NA',
    group: 'All countries',
  },
  {
    code: 'UG',
    code3: 'UGA',
    name: 'Uganda',
    currency: 'UGX',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AF',
    group: 'All countries',
  },
  {
    code: 'UA',
    code3: 'UKR',
    name: 'Ukraine',
    currency: 'UAH',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'EU',
    group: 'All countries',
  },
  {
    code: 'AE',
    code3: 'ARE',
    name: 'United Arab Emirates',
    currency: 'AED',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AS',
    group: 'All countries',
  },
  {
    code: 'GB',
    code3: 'GBR',
    name: 'United Kingdom',
    currency: 'GBP',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'EU',
    group: 'All countries',
  },
  {
    code: 'US',
    code3: 'USA',
    name: 'United States',
    currency: 'USD',
    units: 'imperial',
    priceIncludesTax: false,
    continent: 'NA',
    group: 'All countries',
  },
  {
    code: 'UM',
    code3: 'UMI',
    name: 'United States Minor Outlying Islands',
    currency: 'USD',
    units: 'imperial',
    priceIncludesTax: false,
    continent: 'OC',
    group: 'All countries',
  },
  {
    code: 'UY',
    code3: 'URY',
    name: 'Uruguay',
    currency: 'UYU',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'SA',
    group: 'All countries',
  },
  {
    code: 'UZ',
    code3: 'UZB',
    name: 'Uzbekistan',
    currency: 'UZS',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AS',
    group: 'All countries',
  },
  {
    code: 'VU',
    code3: 'VUT',
    name: 'Vanuatu',
    currency: 'VUV',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'OC',
    group: 'All countries',
  },
  {
    code: 'VA',
    code3: 'VAT',
    name: 'Vatican',
    currency: 'EUR',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'EU',
    group: 'All countries',
  },
  {
    code: 'VE',
    code3: 'VEN',
    name: 'Venezuela',
    currency: 'VES',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'SA',
    group: 'All countries',
  },
  {
    code: 'VN',
    code3: 'VNM',
    name: 'Vietnam',
    currency: 'VND',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AS',
    group: 'All countries',
  },
  {
    code: 'WF',
    code3: 'WLF',
    name: 'Wallis and Futuna',
    currency: 'XPF',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'OC',
    group: 'All countries',
  },
  {
    code: 'EH',
    code3: 'ESH',
    name: 'Western Sahara',
    currency: 'MAD',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AF',
    group: 'All countries',
  },
  {
    code: 'YE',
    code3: 'YEM',
    name: 'Yemen',
    currency: 'YER',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AS',
    group: 'All countries',
  },
  {
    code: 'ZM',
    code3: 'ZMB',
    name: 'Zambia',
    currency: 'ZMW',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AF',
    group: 'All countries',
  },
  {
    code: 'ZW',
    code3: 'ZWE',
    name: 'Zimbabwe',
    currency: 'ZWL',
    units: 'metric',
    priceIncludesTax: true,
    continent: 'AF',
    group: 'All countries',
  },
];
